import styled, { css, SimpleInterpolation } from 'styled-components';

import Media from '../../../assets/styles/media';
import THEME from '../../../assets/styles/config';

export const BubbleSection = styled.span`
  display: flex;
  justify-content: space-around;
  border-top: ${THEME.colors.secondaryFontColor} 1px solid;
  border-bottom: ${THEME.colors.secondaryFontColor} 1px solid;
  padding: 16px 0;
  margin-bottom: 50px;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const BubbleTitle = styled.span`
  font-size: 12px;
  color: ${THEME.colors.secondaryFontColor};
  padding-bottom: 10px;
`;

export const ContentCtn = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 400px;

  ${Media.Below.tablet`
    min-width: unset;
  `}
`;

export const DetailsTable = styled.table`
  > tbody {
    > tr {
      > th {
        font-weight: normal;
        font-size: 16px;
        text-align: start;
        vertical-align: top;
        width: 55%;
        color: ${THEME.colors.secondaryFontColor};
        padding-bottom: 20px;

        ${Media.Below.desktopLarge`
          font-size: 14px;
        `}
      }

      > td {
        font-size: 16px;
        padding-bottom: 20px;

        ${Media.Below.desktopLarge`
          font-size: 14px;
        `}
      }
    }
  }
`;

export const HeadingDescCtn = styled.span`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-bottom: 35px;
`;

export const HeadingDesc = styled.span`
  display: flex;
  font-size: 14px;
`;

export const JobDetailCtn = styled.div`
  width: 100%;
`;

export const JobTitle = styled.h1`
  font-size: 30px;
  font-weight: bold;
  line-height: 1;
  padding-bottom: 15px;
  display: block;
  margin: 0;

  ${Media.Below.desktopLarge`
    font-size: 22px;
  `}
`;

export const LogoCtn = styled.div`
  margin-top: auto;
  width: 100%;

  ${Media.Below.mobileLarge`
    height: 40px;
    margin-top: 0;
    width: unset;
    order: 2;
    flex: 1 1 50%;
  `}
`;

export const SectionTitle = styled.span`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
  display: block;

  ${Media.Below.desktopLarge`
    font-size: 20px;
  `}
`;

export const AssetDetailList = styled.div`
  margin-bottom:20px;
`;

export const RoutineDescriptionCtn = styled.div`
  margin-bottom: 50px;
`;

export const ButtonCtn = styled.div`
  width:100%;
  display: flex;
  align-items:center;
  justify-content: center;
`;

